import * as React from "react";

import { PropertyNavigationBar as SharedUiPropertyNavigationBar } from "@shared-ui/lodging-property-details";
import { PropertyStickyBookBar as SharedUiPropertyStickyBookBar } from "@shared-ui/lodging-property-offers";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutPosition } from "uitk-react-layout-position";

import { ComponentProps, FTNodeOptions } from "typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { FlexModuleModelStore } from "stores/FlexModuleModelStore";

// Custom sticky component while it's being promoted to uitk
import { StackedSticky } from "components/shared/StackedSticky/StackedSticky";

import { Experiment, isVariantEnabled } from "components/utility/experiment";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";
import { withStores } from "stores";

const MARKETING_PARAMS = ["semcid", "emlcid", "mdpcid"];

interface PropertyNavigationBarOptions extends FTNodeOptions {
  hideStickyBookBar?: boolean;
}

export interface PropertyNavigationBarProps extends ComponentProps {
  flexModuleModelStore: FlexModuleModelStore;
}

export const WrappedPropertyNavigationBar = PropertyBexApiWrapper(SharedUiPropertyNavigationBar);
export const WrappedStickyBookBar = PropertyBexApiWrapper(SharedUiPropertyStickyBookBar);

export const PropertyNavigationBar = withStores("flexModuleModelStore")((props: PropertyNavigationBarProps) => {
  const { context, flexModuleModelStore, flexTemplateNode } = props;
  const id = flexTemplateNode?.id || "";

  if (!flexTemplateNode) {
    return null;
  }

  const model = flexModuleModelStore?.getModel(id);
  const options = normalizeOptionsData(flexTemplateNode, model) as PropertyNavigationBarOptions;
  const hideStickyBookBar = options?.hideStickyBookBar;

  const isExperimentEnabled = isVariantEnabled(context, Experiment.SQM_On_Top_Of_the_Dateless_PDP);
  // Do not include the sticky bar for the marketing channels of if hideStickyBookBar attribute is set true in template
  // or if bucketed in the experiment #44219
  const queryParams = context?.queryParams || {};
  const isMktRequest =
    Object.keys(queryParams)
      .map((key) => key.toLocaleLowerCase())
      .filter((key) => MARKETING_PARAMS.includes(key)).length > 0;

  const navigationBar = (
    <UitkSpacing border={["blockend"]}>
      <div>
        <WrappedPropertyNavigationBar context={context} />
      </div>
    </UitkSpacing>
  );

  return (
    <UitkLayoutPosition tag="section" type="relative">
      {!isExperimentEnabled ? <StackedSticky>{navigationBar}</StackedSticky> : <>{navigationBar}</>}

      {!isMktRequest && !hideStickyBookBar && !isExperimentEnabled && (
        <UitkLayoutPosition type="absolute" position={{ right: "three", top: "one" }}>
          <WrappedStickyBookBar context={context} clickTargetRef="startDate" />
        </UitkLayoutPosition>
      )}
    </UitkLayoutPosition>
  );
});

export default PropertyNavigationBar;
